import { render, staticRenderFns } from "./ShareDiet.vue?vue&type=template&id=158d7016&scoped=true&"
import script from "./ShareDiet.vue?vue&type=script&lang=js&"
export * from "./ShareDiet.vue?vue&type=script&lang=js&"
import style0 from "./ShareDiet.vue?vue&type=style&index=0&id=158d7016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d7016",
  null
  
)

export default component.exports